import React, { Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';
import NumberFormat from 'react-number-format';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    colors,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Checkbox,
    Switch
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.cyan[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    userlist: {
        width: '100%',
        maxHeight: 340,
        overflow: 'auto'
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const Create = ({ item, open, closeCreation, createValues, dependencies, updateDependencies, vision }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        {vision.name}
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                nome: Yup.string().max(255).required('Nome é obrigatório')
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid
                                    container
                                    spacing={2}
                                >

                                    {(vision.id != 22) ?
                                        <Fragment>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.nome && errors.nome)}
                                                    required
                                                    fullWidth
                                                    label="Nome"
                                                    margin="normal"
                                                    name="nome"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.nome}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                        </Fragment>
                                        :
                                        ""
                                    }

                                    {(vision.id == 22) ?
                                        <Fragment>
                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.id && errors.id)}
                                                    required
                                                    fullWidth
                                                    label="Placa"
                                                    margin="normal"
                                                    name="id"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.id}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ readOnly: false }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.marca && errors.marca)}
                                                    fullWidth
                                                    label="Marca"
                                                    margin="normal"
                                                    name="marca"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.marca}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.modelo && errors.modelo)}
                                                    fullWidth
                                                    label="Modelo"
                                                    margin="normal"
                                                    name="modelo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.modelo}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.nome && errors.nome)}
                                                    required
                                                    fullWidth
                                                    label="Nome"
                                                    margin="none"
                                                    name="nome"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.nome}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                        </Fragment>
                                        :
                                        ""
                                    }

                                    {(vision.id == 2) ?
                                        <Fragment>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.descricao && errors.descricao)}
                                                    fullWidth
                                                    label="Descrição da Categoria"
                                                    margin="nome"
                                                    name="descricao"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.descricao}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                container
                                                alignItems='baseline'>

                                                <Grid
                                                    item>
                                                    <Switch
                                                        checked={values.extra}
                                                        onChange={handleChange}
                                                        name="extra" />
                                                </Grid>

                                                <Grid
                                                    item>
                                                    <Typography variant="h6">
                                                        É Item Extra na LPU
                                                    </Typography>

                                                </Grid>
                                            </Grid>


                                        </Fragment>
                                        : ""
                                    }

                                    {(vision.id == 13) ?
                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="PRESTADORA" required >Departamento</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.PRESTADORA && errors.PRESTADORA)}
                                                    helperText={touched.PRESTADORA && errors.PRESTADORA}
                                                    value={values.PRESTADORA}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Departamento"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'PRESTADORA',
                                                        id: 'PRESTADORA',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.providers.map((provider) => (
                                                        <MenuItem key={provider.id} value={provider.id}>{provider.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        : ""
                                    }

                                    {(vision.id == 21) ?
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="operacao" required >Operação</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.operacao && errors.operacao)}
                                                    helperText={touched.operacao && errors.operacao}
                                                    value={values.operacao}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Operação"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'operacao',
                                                        id: 'operacao',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    <MenuItem value={1}>
                                                        <em>Crédito</em>
                                                    </MenuItem>
                                                    <MenuItem value={-1}>
                                                        <em>Débito</em>
                                                    </MenuItem>

                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        : ""
                                    }

                                    {(vision.id == 21) ?
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="especificado" required >Especificação</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.especificado && errors.especificado)}
                                                    helperText={touched.especificado && errors.especificado}
                                                    value={values.especificado}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Especificação"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'especificado',
                                                        id: 'especificado',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    <MenuItem value={1}>
                                                        <em>Especificação Obrigatória</em>
                                                    </MenuItem>
                                                    <MenuItem value={0}>
                                                        <em>Livre</em>
                                                    </MenuItem>

                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        : ""
                                    }

                                    {(vision.id == 18) ?
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="TIPO" required >Tipo</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.TIPO && errors.TIPO)}
                                                    helperText={touched.TIPO && errors.TIPO}
                                                    value={values.TIPO}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Tipo"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'TIPO',
                                                        id: 'TIPO',
                                                    }}
                                                >

                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>

                                                    {dependencies.infrasType.map((infratype) => (
                                                        <MenuItem key={infratype.id} value={infratype.id}>{infratype.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        : ""
                                    }


                                    {(vision.id == 19) ?
                                        <Fragment>
                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="nome">
                                                    <InputLabel shrink htmlFor="INFRAESTRUTURA" required >Infraestrutura</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.INFRAESTRUTURA && errors.INFRAESTRUTURA)}
                                                        helperText={touched.INFRAESTRUTURA && errors.INFRAESTRUTURA}
                                                        value={values.INFRAESTRUTURA}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Infraestrutura"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'INFRAESTRUTURA',
                                                            id: 'INFRAESTRUTURA',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>

                                                        {dependencies.infras.map((infra) => (
                                                            <MenuItem key={infra.id} value={infra.id}>{infra.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="nome">
                                                    <InputLabel shrink htmlFor="tipoEntrada" required >Tipo de Entrada</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.tipoEntrada && errors.tipoEntrada)}
                                                        helperText={touched.tipoEntrada && errors.tipoEntrada}
                                                        value={values.tipoEntrada}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Tipo de Entrada"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'tipoEntrada',
                                                            id: 'tipoEntrada',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>

                                                        <MenuItem value="4">
                                                            <em>Data</em>
                                                        </MenuItem>
                                                        <MenuItem value="2">
                                                            <em>Número</em>
                                                        </MenuItem>
                                                        <MenuItem value="3">
                                                            <em>Sim / Não</em>
                                                        </MenuItem>
                                                        <MenuItem value="1">
                                                            <em>Texto</em>
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.sufixo && errors.sufixo)}
                                                    fullWidth
                                                    label="Sufixo ou Unidade de Medida"
                                                    margin="nome"
                                                    name="sufixo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.sufixo}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <NumberFormat
                                                    error={Boolean(touched.tamanho && errors.tamanho)}
                                                    fullWidth
                                                    required
                                                    label="Tamanho"
                                                    margin="nome"
                                                    name="tamanho"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.tamanho}
                                                    variant="outlined"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={2}>
                                                <Typography
                                                    color="textPrimary"
                                                    gutterBottom
                                                    variant="h6"
                                                >
                                                    Obrigatório
                                                </Typography>
                                                <ColorCheckbox
                                                    edge="end"
                                                    onChange={handleChange}
                                                    name="obrigatorio"
                                                    checked={values.obrigatorio}
                                                    id="obrigatorio">
                                                </ColorCheckbox>

                                            </Grid>

                                        </Fragment>
                                        : ""
                                    }

                                    {(vision.id == 16) ?
                                        <Fragment>
                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.supervisor && errors.supervisor)}
                                                    fullWidth
                                                    label="Supervisor"
                                                    margin="normal"
                                                    name="supervisor"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.supervisor}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="normal">
                                                    <InputLabel shrink htmlFor="marcador" >Cor do Marcador</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.marcador && errors.marcador)}
                                                        helperText={touched.marcador && errors.marcador}
                                                        value={values.marcador}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Cor do Marcador"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'marcador',
                                                            id: 'marcador',
                                                        }}
                                                    >

                                                        <MenuItem key={null} value={null}>
                                                            <em>Transparente</em>
                                                        </MenuItem>

                                                        {dependencies.colors.map((marcador) => (
                                                            <MenuItem key={marcador.id} value={marcador.id}>{marcador.name}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                        </Fragment>

                                        : ""}

                                </Grid>
                                <br></br>
                                <Divider />
                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
